import { render, staticRenderFns } from "./TypeSelectorTree.vue?vue&type=template&id=22c482fa&"
import script from "./TypeSelectorTree.vue?vue&type=script&lang=ts&"
export * from "./TypeSelectorTree.vue?vue&type=script&lang=ts&"
import style0 from "./TypeSelectorTree.vue?vue&type=style&index=0&id=22c482fa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports